import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=fab713a8&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=fab713a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab713a8",
  null
  
)

export default component.exports